import { render, staticRenderFns } from "./category-dialog.vue?vue&type=template&id=055c6d60"
import script from "./category-dialog.vue?vue&type=script&lang=js"
export * from "./category-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports